<div style="padding: 30px">
  <div class="close-icon" mat-button (click)="dialogRef.close()"></div>
  <mat-tab-group *ngIf="form" [formGroup]="form">
    <mat-tab [label]="dictionaryItem.dictionary == 'Service' ? 'Mapping' : 'General'">
      <h2
        style="font-family: Roboto, 'Helvetica Neue', sans-serif;">{{ dictionaryItem.itemId ? 'Edit' : 'Create' }} {{ dictionaryItem.dictionary === 'Vendor' ? 'Vendor' : dictionaryItem.dictionary === 'Service' ? 'Solution' : dictionaryItem.dictionary === 'PolicyContent' ? 'Policy Content' : dictionaryItem.dictionary }}</h2>
      <div [formGroup]="form">
        <div style="display: flex; flex-direction: row;">
          <div [hidden]="dictionaryItem.dictionary !== 'Service'" style="flex:1 1 15%">
            <mat-form-field class="example-full-width" style="width: 90%;">
              <mat-label>Vendor</mat-label>
              <mat-select formControlName="parentId">
                <mat-option [value]="item.itemId" *ngFor="let item of parents">{{ item.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="flex:1 1 15%">
            <mat-form-field class="example-full-width" style="width: 90%;">
              <mat-label>{{ dictionaryItem.dictionary === 'Vendor' ? 'Vendor Name' : dictionaryItem.dictionary === 'Service' ? 'Solution Name' : dictionaryItem.dictionary === 'Topic' ? 'Topic Name' : dictionaryItem.dictionary === 'FindingsNotes' ? 'Findings/Notes Name' : dictionaryItem.dictionary === 'Recommendations' ? 'Recommendation Name' : 'Policy Content Name' }}</mat-label>
              <input matInput formControlName="name">
            </mat-form-field>
          </div>
          <div style="flex:1 1 15" *ngIf="dictionaryItem.dictionary === 'Vendor'">
            <img [src]="logoUrl" style="max-width: 64px; max-height: 64px;" *ngIf="dictionaryItem.logoFileName" />
            <label class="mat-button mat-raised-button" for="updateClientCompanyLogo"
                   matTooltip="{{this.constants.IMAGE_FILE_DESCRIPTION}}">
              <i class="pi pi-paperclip"></i> Upload new Logo
              <input id="updateClientCompanyLogo"
                     type="file"
                     accept="{{this.constants.IMAGE_FILE_EXTENSIONS}}"
                     (change)="addLogo($event)"
                     name="updateClientCompanyLogo"
                     style="display: none;" />
            </label>
          </div>
          <div style="flex:1 1 25%" *ngIf="dictionaryItem.dictionary == 'Service' || dictionaryItem.dictionary === 'PolicyContent'">
            <div class="example-full-width" style="width: 90%;">
              <mat-label>Topic</mat-label>
              <mat-select formControlName="securityTopic">
                @for (topic of topics; track topic.name) {
                  <mat-option [value]="topic.name">{{ topic.name }}</mat-option>
                }
              </mat-select>
            </div>
          </div>
          <div style="flex:1 1 15%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;">
              <mat-label>Sub-Topic</mat-label>
              <input matInput formControlName="topic">
            </mat-form-field>
          </div>
          <div style="flex:1 1 30%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;">
              <mat-label>Supporting Features</mat-label>
              <input matInput formControlName="supportingFeatures">
            </mat-form-field>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="flex:1 1 15%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;">
              <mat-label>Delivery Method</mat-label>
              <input matInput formControlName="fulfillmentMethod">
            </mat-form-field>
          </div>
          <div style="flex:1 1 10%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;">
              <mat-label>Responsibility</mat-label>
              <input matInput formControlName="inheritance">
            </mat-form-field>
          </div>
          <div style="flex:1 1 10%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;" floatLabel="always">
              <mat-label>Price</mat-label>
              <input matInput formControlName="price">
            </mat-form-field>
          </div>
          <div style="flex:1 1 10%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;" floatLabel="always">
              <mat-label>Config Details</mat-label>
              <input matInput formControlName="configDetails">
            </mat-form-field>
          </div>
          <div style="flex:1 1 22%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;" floatLabel="always">
              <mat-label>Contact</mat-label>
              <input matInput formControlName="contact">
            </mat-form-field>
          </div>
          <div style="flex:1 1 20%" *ngIf="dictionaryItem.dictionary == 'Service'">
            <mat-form-field class="example-full-width" style="width: 90%;">
              <mat-label>URL</mat-label>
              <input matInput formControlName="url">
            </mat-form-field>
          </div>
          <div style="flex:1 1 10%"
               *ngIf="dictionaryItem.dictionary !== 'Topic' && dictionaryItem.dictionary !== 'PolicyContent'">
            <mat-form-field class="example-full-width">
              <mat-label>Last Updated</mat-label>
              <input matInput name="lastUpdated" formControlName="lastUpdated" [matDatepicker]="pickerLastUpdated">
              <mat-datepicker-toggle matSuffix [for]="pickerLastUpdated"></mat-datepicker-toggle>
              <mat-datepicker #pickerLastUpdated></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;"
             *ngIf="dictionaryItem.dictionary === 'Recommendations' || dictionaryItem.dictionary === 'PolicyContent'">
          <div style="flex:1 1 100%">
            <label
              style="color: rgba(0,0,0,.54); font-weight: bold; margin-top: 10px;">{{ dictionaryItem.dictionary == 'PolicyContent' ? 'Content' : 'Configuration Options & Implementation' }}
              <span class="pi pi-pencil"
                    (click)="visibility.detailsEdit = !visibility.detailsEdit"></span></label>
            <div class="ql-editor" *ngIf="!visibility.detailsEdit"
                 [innerHTML]="addToken(form.controls['details'].value) | sanitizeHtml"></div>
            <p-editor matInput
                      type="text"
                      *ngIf="visibility.detailsEdit"
                      formControlName="details">
              <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
                <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
                <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
                <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
              </p-header>
            </p-editor>
          </div>
        </div>
        @if (dictionaryItem.dictionary !== 'PolicyContent') {
          <p-table [value]="dictionaryItem.dictionaryControlItems">
            <ng-template pTemplate="header">
              <tr>
                <th>Framework</th>
                <th>Control&nbsp;ID</th>
                <ng-container *ngIf="dictionaryItem.dictionary == 'Vendor'">
                  <th>Configuration Options & Implementation</th>
                  <th>Customer Responsibilities</th>
                </ng-container>
                <th>Recommended</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr>
                <td>{{ item.complianceAreaName }}</td>
                <td>{{ item.complianceAreaControlId }}</td>
                <ng-container *ngIf="dictionaryItem.dictionary == 'Vendor'">
                  <td>{{ item.configurationOptions }}</td>
                  <td>{{ item.customerResponsibilities }}</td>
                </ng-container>
                <td>
                  <mat-checkbox [(ngModel)]="item.isRecommended" [ngModelOptions]="{standalone: true}"></mat-checkbox>
                </td>
                <td>
                  <i class="pi pi-trash cursor-pointer" (click)="detachControlItem(item)"></i>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <i class="pi pi-plus cursor-pointer" (click)="addControlItem()"></i>
        }
      </div>
    </mat-tab>
    <ng-container *ngIf="dictionaryItem.dictionary == 'Service' || dictionaryItem.dictionary == 'FindingsNotes'">
      <mat-tab label="Guidance">
        <div style="display: flex; flex-direction: row;">
          <div style="flex:1 1 100%">
            <label
              style="color: rgba(0,0,0,.54); font-weight: bold; margin-top: 10px;">{{ dictionaryItem.dictionary == 'Service' ? 'Description' : 'Configuration Options & Implementation' }}
              <span class="pi pi-pencil"
                    (click)="visibility.detailsEdit = !visibility.detailsEdit"></span></label>
            <div class="ql-editor" *ngIf="!visibility.detailsEdit"
                 [innerHTML]="addToken(form.controls['details'].value) | sanitizeHtml"></div>
            <p-editor matInput
                      type="text"
                      *ngIf="visibility.detailsEdit"
                      formControlName="details">
              <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
                <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
                <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
                <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
              </p-header>
            </p-editor>
          </div>
        </div>
        <div *ngIf="dictionaryItem.dictionary == 'Service'">
          <label
            style="color: rgba(0,0,0,.54); font-weight: bold; margin-top: 10px;">Guidance
            <span class="pi pi-pencil"
                  (click)="visibility.guidanceEdit = !visibility.guidanceEdit"></span></label>
          <div class="ql-editor" *ngIf="!visibility.guidanceEdit"
               [innerHTML]="addToken(form.controls['guidance'].value) | sanitizeHtml"></div>
          <p-editor matInput
                    type="text"
                    *ngIf="visibility.guidanceEdit"
                    formControlName="guidance">
            <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
              <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
              <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
              <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
            </p-header>
          </p-editor>
        </div>
        <div *ngIf="dictionaryItem.dictionary == 'Service'">
          <label
            style="color: rgba(0,0,0,.54); font-weight: bold; margin-top: 10px;">Implementation Details
            <span class="pi pi-pencil"
                  (click)="visibility.details2Edit = !visibility.details2Edit"></span></label>
          <div class="ql-editor" *ngIf="!visibility.details2Edit"
               [innerHTML]="addToken(form.controls['details2'].value) | sanitizeHtml"></div>
          <p-editor matInput
                    type="text"
                    *ngIf="visibility.details2Edit"
                    formControlName="details2">
            <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
              <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
              <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
              <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
            </p-header>
          </p-editor>
        </div>
        <div *ngIf="dictionaryItem.dictionary == 'Service'">
          <label
            style="color: rgba(0,0,0,.54); font-weight: bold; margin-top: 10px;">Customer Responsibilities
            <span class="pi pi-pencil"
                  (click)="visibility.customerResponsibilitiesEdit = !visibility.customerResponsibilitiesEdit"></span></label>
          <div class="ql-editor" *ngIf="!visibility.customerResponsibilitiesEdit"
               [innerHTML]="addToken(form.controls['customerResponsibilities'].value) | sanitizeHtml"></div>
          <p-editor matInput
                    type="text"
                    *ngIf="visibility.customerResponsibilitiesEdit"
                    formControlName="customerResponsibilities">
            <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
              <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
              <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
              <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
            </p-header>
          </p-editor>
        </div>
        <div *ngIf="dictionaryItem.dictionary == 'Service'">
          <label style="color: rgba(0,0,0,.54); font-weight: bold; margin-top: 10px;">Config Info
            <span class="pi pi-pencil"
                  (click)="visibility.configInfoEdit = !visibility.configInfoEdit"></span></label>
          <div class="ql-editor" *ngIf="!visibility.configInfoEdit"
               [innerHTML]="addToken(form.controls['configInfo'].value) | sanitizeHtml"></div>
          <p-editor matInput type="text" *ngIf="visibility.configInfoEdit"
                    formControlName="configInfo">
            <p-header>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="huge">Heading</option>
                  <option value="large">Subheading</option>
                  <option selected></option>
                  <option value="small">Small</option>
                </select>
                <select class="ql-font">
                  <option selected="">Sans Serif</option>
                  <option value="serif">Serif</option>
                  <option value="monospace">Monospace</option>
                </select>
              </span>
              <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select> <span class="ql-format-separator"></span>
                <select class="ql-background">
                  <option selected="selected"></option>
                  <option value="#e60000"></option>
                  <option value="#ff9900"></option>
                  <option value="#ffff00"></option>
                  <option value="#008a00"></option>
                  <option value="#0066cc"></option>
                  <option value="#9933ff"></option>
                  <option value="#ffffff"></option>
                  <option value="#facccc"></option>
                  <option value="#ffebcc"></option>
                  <option value="#ffffcc"></option>
                  <option value="#cce8cc"></option>
                  <option value="#cce0f5"></option>
                  <option value="#ebd6ff"></option>
                  <option value="#bbbbbb"></option>
                  <option value="#f06666"></option>
                  <option value="#ffc266"></option>
                  <option value="#ffff66"></option>
                  <option value="#66b966"></option>
                  <option value="#66a3e0"></option>
                  <option value="#c285ff"></option>
                  <option value="#888888"></option>
                  <option value="#a10000"></option>
                  <option value="#b26b00"></option>
                  <option value="#b2b200"></option>
                  <option value="#006100"></option>
                  <option value="#0047b2"></option>
                  <option value="#6b24b2"></option>
                  <option value="#444444"></option>
                  <option value="#5c0000"></option>
                  <option value="#663d00"></option>
                  <option value="#666600"></option>
                  <option value="#003700"></option>
                  <option value="#002966"></option>
                  <option value="#3d1466"></option>
                </select> <span class="ql-format-separator"></span>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <select title="Text Alignment" class="ql-align">
                  <option selected>Left</option>
                  <option value="center" label="Center"></option>
                  <option value="right" label="Right"></option>
                  <option value="justify" label="Justify"></option>
                </select>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Link" class="ql-link"></button>
                <button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                        (click)="selectDocument(el)">D</button>
                <button aria-label="Image" class="ql-image"></button>
                <button aria-label="Code block" class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button aria-label="Clean" class="ql-clean"></button>
              </span>
            </p-header>
          </p-editor>
        </div>
      </mat-tab>
    </ng-container>
  </mat-tab-group>
  <div style="text-align: right;">
    <button mat-raised-button (click)="onSave()" style="border-radius: 6px;">Save</button>
    <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
    <button *ngIf="dictionaryItem.itemId" mat-raised-button style="border-radius: 6px;"
            mwlConfirmationPopover [title]="'Delete The Vault Item'"
            [popoverMessage]="'You are going to delete this The Vault Item. Are you sure?'"
            [appendToBody]="true"
            [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
            (confirm)="onDelete()">Delete
    </button>
  </div>
</div>
